(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[5672],{

/***/ 71652:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/socios",
      function () {
        return __webpack_require__(68040);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 31233:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ components_Image; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(99534);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(45697);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
;// CONCATENATED MODULE: ./src/components/Image/Picture.js


var defaultProps = {};
var propTypes = {
    children: (prop_types_default()).node.isRequired
};
function Picture(param) {
    var children = param.children;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("picture", {
        children: children
    });
};
Picture.defaultProps = defaultProps;
Picture.propTypes = propTypes;

// EXTERNAL MODULE: ./node_modules/clsx/dist/clsx.m.js
var clsx_m = __webpack_require__(86010);
;// CONCATENATED MODULE: ./src/components/Image/Img.js



/* eslint-disable @next/next/no-img-element */ 


var Img_defaultProps = {
    fluid: true,
    title: null,
    className: null
};
var Img_propTypes = {
    src: (prop_types_default()).string.isRequired,
    alt: (prop_types_default()).string.isRequired,
    fluid: (prop_types_default()).bool,
    title: (prop_types_default()).string,
    className: (prop_types_default()).string
};
function Img(_param) {
    var src = _param.src, alt = _param.alt, fluid = _param.fluid, title = _param.title, className = _param.className, rest = (0,_object_without_properties/* default */.Z)(_param, [
        "src",
        "alt",
        "fluid",
        "title",
        "className"
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("img", (0,_object_spread/* default */.Z)({
        src: src,
        alt: alt,
        title: title,
        className: (0,clsx_m/* default */.Z)(fluid && "h-auto max-w-full", className),
        loading: "lazy"
    }, rest));
}
Img.defaultProps = Img_defaultProps;
Img.propTypes = Img_propTypes;
var ImgForwardRef = /*#__PURE__*/ (0,react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Img, (0,_object_spread/* default */.Z)({
        ref: ref
    }, props));
});
ImgForwardRef.displayName = "ImgForwardRef";
/* harmony default export */ var Image_Img = (ImgForwardRef);

;// CONCATENATED MODULE: ./src/components/Image/isRemote.js
function isRemote(src) {
    return src.indexOf("//") !== -1;
};

;// CONCATENATED MODULE: ./src/components/Image/localImageSource.js
function localImageSource(src) {
    return "/images/".concat(src);
};

;// CONCATENATED MODULE: ./src/components/Image/Source.js


var Source_defaultProps = {
    sizes: null,
    srcset: null,
    media: "all"
};
var Source_propTypes = {
    sizes: (prop_types_default()).string,
    srcset: (prop_types_default()).string,
    type: (prop_types_default()).string.isRequired,
    media: prop_types_default().oneOfType([
        prop_types_default().oneOf([
            "all",
            "print",
            "screen",
            "speech"
        ]),
        (prop_types_default()).string, 
    ])
};
function Source(param) {
    var sizes = param.sizes, srcset = param.srcset, type = param.type, media = param.media;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("source", {
        sizes: sizes,
        srcSet: srcset,
        type: type,
        media: media
    });
};
Source.defaultProps = Source_defaultProps;
Source.propTypes = Source_propTypes;

;// CONCATENATED MODULE: ./src/components/Image/renderSources.js


function renderSources(sources) {
    var keys = Object.keys(sources);
    if (keys === null || keys.length === 0) {
        return null;
    }
    return keys.map(function(type, index) {
        var src = sources[type];
        var srcSet = src;
        var sizes = null;
        if (Array.isArray(src) === true) {
            srcSet = src[0];
            sizes = src[1];
        }
        return renderSource(index, type, srcSet, sizes);
    });
};
function renderSource(index, type, srcSet) {
    var sizes = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : null;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Source, {
        type: type,
        srcSet: srcSet,
        sizes: sizes
    }, "source-".concat(index));
}

;// CONCATENATED MODULE: ./src/components/Image/Image.js










var Image_defaultProps = {
    fluid: false,
    sources: null,
    srcSet: null,
    sizes: null,
    className: ""
};
var Image_propTypes = {
    src: (prop_types_default()).string.isRequired,
    sources: prop_types_default().oneOfType([
        (prop_types_default()).string,
        (prop_types_default()).object
    ]),
    srcSet: (prop_types_default()).string,
    sizes: (prop_types_default()).string,
    fluid: (prop_types_default()).bool,
    className: (prop_types_default()).string
};
function Image(_param) {
    var src = _param.src, sources = _param.sources, rest = (0,_object_without_properties/* default */.Z)(_param, [
        "src",
        "sources"
    ]);
    var hasSources = sources && sources.length !== 0;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Picture, {
        children: [
            hasSources && renderSources(sources),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Image_Img, (0,_object_spread/* default */.Z)({
                src: isRemote(src) ? src : localImageSource(src)
            }, rest))
        ]
    });
}
Image.defaultProps = Image_defaultProps;
Image.propTypes = Image_propTypes;
var ImageForwardRef = /*#__PURE__*/ (0,react.forwardRef)(function(_param, ref) /*#__PURE__*/ {
    var alt = _param.alt, props = (0,_object_without_properties/* default */.Z)(_param, [
        "alt"
    ]);
    return (0,jsx_runtime.jsx)(Image, (0,_object_spread/* default */.Z)({
        ref: ref,
        alt: alt
    }, props));
});
ImageForwardRef.displayName = "ImageForwardRef";
/* harmony default export */ var Image_Image = (ImageForwardRef);

;// CONCATENATED MODULE: ./src/components/Image/index.js

/* harmony default export */ var components_Image = (Image_Image);


/***/ }),

/***/ 68040:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSG": function() { return /* binding */ __N_SSG; },
  "default": function() { return /* binding */ Partners; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(99534);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./src/components/Container/index.js
var Container = __webpack_require__(30341);
// EXTERNAL MODULE: ./src/components/Link/index.js + 2 modules
var Link = __webpack_require__(48300);
// EXTERNAL MODULE: ./src/view/HeaderSub/index.js + 1 modules
var HeaderSub = __webpack_require__(76405);
// EXTERNAL MODULE: ./node_modules/clsx/dist/clsx.m.js
var clsx_m = __webpack_require__(86010);
// EXTERNAL MODULE: ./src/components/Image/index.js + 7 modules
var Image = __webpack_require__(31233);
// EXTERNAL MODULE: ./src/hooks/useHover.js
var useHover = __webpack_require__(82163);
;// CONCATENATED MODULE: ./src/domain/Partners/PartnerListing.js





function Partner(param) {
    var uri = param.uri, title = param.title, featuredImage = param.featuredImage, excerpt = param.excerpt;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.Z, {
        href: uri,
        className: "relative w-full transition duration-300 ease-in-out bg-white rounded-lg ring-1 ring-black ring-opacity-10 hover:ring-opacity-20 lg:rounded-xl xl:rounded-2xl",
        children: function(param) {
            var isHovering = param.isHovering;
            return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "relative z-20 flex items-start w-full px-6 py-6 space-x-6 bg-white rounded-lg lg:rounded-xl lg:py-8 xl:rounded-2xl",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
                                    className: (0,clsx_m/* default */.Z)("h-16 w-16 transform rounded-full shadow transition duration-300 ease-in-out", isHovering === false && "scale-100", isHovering === true && "scale-75"),
                                    alt: title,
                                    src: featuredImage.node.sourceUrl,
                                    srcSet: featuredImage.node.srcSet
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "flex flex-col flex-1 space-y-2",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                        className: "text-lg font-medium lg:text-xl lg:font-semibold",
                                        children: title
                                    }),
                                    excerpt !== null && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "text-base leading-7 text-gray-500 lg:text-lg",
                                        dangerouslySetInnerHTML: {
                                            __html: excerpt
                                        }
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (0,clsx_m/* default */.Z)("absolute inset-0 z-0 transform rounded-lg shadow-outside transition duration-300 ease-in-out lg:rounded-xl xl:rounded-2xl", isHovering === false && "scale-90 opacity-0", isHovering === true && "scale-100 opacity-100")
                    })
                ]
            });
        }
    });
};

;// CONCATENATED MODULE: ./src/pages/socios/index.js







var __N_SSG = true;
function Partners(param) {
    var partners = param.partners;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "bg-white",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(HeaderSub/* default */.Z, {
                pageTitle: /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.Z, {
                    className: "text-green-500",
                    href: "/socios",
                    children: "Nuestros socios y colaboradores"
                }),
                menu: [
                    {
                        title: "Listado de socios",
                        url: "/socios"
                    },
                    {
                        title: "\xdanete al programa",
                        url: "/programa-de-socios",
                        useArrow: true
                    }, 
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "pt-10 lg:pt-16",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* default */.ZP, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "grid grid-cols-1 lg:grid-cols-12",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "text-center lg:col-span-8 lg:col-start-3",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("h1", {
                                className: "text-4xl font-bold tracking-tight lg:text-5xl",
                                children: [
                                    "Alianzas duraderas para liderar la\xa0",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "text-green-500",
                                        children: "transformaci\xf3n \xe1gil"
                                    })
                                ]
                            })
                        })
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "z-100 relative",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "bg-gradient-to-tl from-gray-100 to-white py-10 lg:py-20",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* default */.ZP, {
                            className: "space-y-10 lg:space-y-12",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "grid grid-cols-1 gap-10 lg:grid-cols-12",
                                children: partners.map(function(_param) /*#__PURE__*/ {
                                    var id = _param.id, partner = (0,_object_without_properties/* default */.Z)(_param, [
                                        "id"
                                    ]);
                                    return (0,jsx_runtime.jsx)("div", {
                                        className: "flex lg:col-span-6",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Partner, (0,_object_spread/* default */.Z)({}, partner), id)
                                    }, "partner-".concat(id));
                                })
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "bg-green-500 bg-gradient-to-tl from-green-500 to-green-400 py-10 lg:py-20",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* default */.ZP, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "grid grid-cols-1 gap-10 lg:grid-cols-12 lg:gap-20",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Link/* default */.Z, {
                                        href: "/entrenadores",
                                        className: "relative flex transform flex-col space-x-8 overflow-hidden rounded-xl bg-white p-8 pl-28 shadow-lg transition duration-500 ease-in-out hover:shadow-2xl md:flex-row md:items-center lg:col-span-6 lg:rounded-2xl",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: "absolute left-0 top-0 bottom-0 flex items-center",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
                                                        className: "relative z-10 -ml-2 h-40 w-40",
                                                        width: "48",
                                                        height: "48",
                                                        viewBox: "0 0 48 48",
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                                className: "fill-current text-green-200",
                                                                d: "M8,41l5.818-10.889L18.182,28.3l2.909-5.445h5.818L29.818,28.3l4.364,1.815L40,41H8Z"
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                                className: "fill-current text-green-500",
                                                                d: "M32,17l-1,3H30l-1,3-4,3H23l-4-3-1-3H17l-1-3h2l-1-6,7-4,7,4-1,6h2Z"
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: "absolute left-0 top-0 bottom-0 z-0 w-28 bg-gradient-to-b from-green-200 to-transparent"
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: "flex-1 space-y-4",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                                        className: "flex items-center space-x-3",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                            className: "text-xl font-semibold lg:text-2xl",
                                                            children: "Encuentra un entrenador"
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                                        className: "text-base font-normal text-gray-500 lg:text-lg",
                                                        children: "Certificado para ense\xf1ar y acompa\xf1ar a tu equipo en la adopci\xf3n de la cultura \xe1gil."
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                        className: "inline-flex items-center space-x-1 text-lg font-semibold",
                                                        role: "button",
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                className: "text-green-500",
                                                                children: "Nuestros entrenadores"
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
                                                                xmlns: "http://www.w3.org/2000/svg",
                                                                className: "h-5 w-5 text-gray-500",
                                                                viewBox: "0 0 20 20",
                                                                fill: "currentColor",
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                                    fillRule: "evenodd",
                                                                    d: "M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z",
                                                                    clipRule: "evenodd"
                                                                })
                                                            })
                                                        ]
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Link/* default */.Z, {
                                        href: "/programa-de-socios",
                                        className: "relative flex transform flex-col space-x-8 overflow-hidden rounded-xl bg-white p-8 pl-28 shadow-lg transition duration-500 ease-in-out hover:shadow-2xl md:flex-row md:items-center lg:col-span-6 lg:rounded-2xl",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: "absolute left-0 top-0 bottom-0 flex items-center",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
                                                        className: "relative z-10 h-32 w-32",
                                                        viewBox: "0 0 48 48",
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                                className: "fill-current text-green-200",
                                                                d: "M29.624,43.785L25.381,32.472l7.778-7.778,2.075,8.735ZM4.168,18.329l10.357-5.611,8.735,2.075-7.778,7.778ZM5.624,34.991c1.92-4.929,5.24-2.274,5.24-2.274l2.222,2.217,2.2,2.193s2.627,3.28-2.295,5.213a12.725,12.725,0,0,1-4.578.376c-0.815-.076-3.537,1.6-4.347,1.222-0.39-.814,1.288-3.537,1.207-4.355A12.681,12.681,0,0,1,5.624,34.991Z"
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                                className: "fill-current text-green-500",
                                                                d: "M10.7,24.537C29.323,6.122,43.983,3.986,43.983,3.986S41.823,18.484,23.2,36.9c0,0-4.841,5.327-11.38-1.14A8.244,8.244,0,0,1,10.7,24.537Z"
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                                className: "fill-current text-green-200",
                                                                d: "M27.646,20.336a4.454,4.454,0,1,1-6.346-.058A4.512,4.512,0,0,1,27.646,20.336Z"
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: "absolute left-0 top-0 bottom-0 z-0 w-28 bg-gradient-to-b from-green-100 to-white"
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: "flex-1 space-y-4",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                                        className: "flex items-center space-x-3",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                            className: "text-xl font-semibold lg:text-2xl",
                                                            children: "\xdanete al programa de socios"
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                                        className: "text-base font-normal text-gray-500 lg:text-lg",
                                                        children: "Para obtener juntos un mayor impacto en la adopci\xf3n de la cultura \xe1gil."
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                        className: "inline-flex items-center space-x-1 text-lg font-semibold",
                                                        role: "button",
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                className: "text-green-500",
                                                                children: "Quiero conocer m\xe1s"
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
                                                                xmlns: "http://www.w3.org/2000/svg",
                                                                className: "h-5 w-5 text-gray-500",
                                                                viewBox: "0 0 20 20",
                                                                fill: "currentColor",
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                                    fillRule: "evenodd",
                                                                    d: "M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z",
                                                                    clipRule: "evenodd"
                                                                })
                                                            })
                                                        ]
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            })
                        })
                    })
                ]
            })
        ]
    });
};


/***/ }),

/***/ 76405:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ view_HeaderSub; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(45697);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
// EXTERNAL MODULE: ./node_modules/clsx/dist/clsx.m.js
var clsx_m = __webpack_require__(86010);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./src/components/Container/index.js
var Container = __webpack_require__(30341);
// EXTERNAL MODULE: ./src/components/Link/index.js + 2 modules
var Link = __webpack_require__(48300);
;// CONCATENATED MODULE: ./src/view/HeaderSub/HeaderSub.js






var defaultProps = {
    menu: []
};
var propTypes = {
    pageTitle: (prop_types_default()).node.isRequired,
    menu: prop_types_default().arrayOf(prop_types_default().shape({
        title: (prop_types_default()).string.isRequired,
        url: (prop_types_default()).string.isRequired
    }))
};
function HeaderSub(param) {
    var pageTitle = param.pageTitle, menu = param.menu;
    var router = (0,next_router.useRouter)();
    var hasPageTitle = pageTitle !== null;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* default */.ZP, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "relative z-20 flex items-center py-4 overflow-y-auto lg:py-6",
            children: [
                hasPageTitle && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "flex-1",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                        className: "hidden text-base font-semibold text-gray-900 md:block lg:text-lg xl:text-xl",
                        children: pageTitle
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("nav", {
                    className: "flex items-center max-w-full space-x-6",
                    children: menu.map(function(param, index) {
                        var title = param.title, url = param.url, useArrow = param.useArrow;
                        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Link/* default */.Z, {
                            className: (0,clsx_m/* default */.Z)("flex items-center space-x-2 whitespace-nowrap", router.pathname === url && " cursor-default font-normal text-gray-500", router.pathname !== url && "font-semibold text-green-600 hover:text-gray-900"),
                            href: url,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "text-base leading-4",
                                    children: title
                                }),
                                useArrow && /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
                                    className: "w-4 h-4",
                                    xmlns: "http://www.w3.org/2000/svg",
                                    viewBox: "0 0 20 20",
                                    fill: "currentColor",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                        fillRule: "evenodd",
                                        d: "M12.293 5.293a1 1 0 011.414 0l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414-1.414L14.586 11H3a1 1 0 110-2h11.586l-2.293-2.293a1 1 0 010-1.414z",
                                        clipRule: "evenodd"
                                    })
                                })
                            ]
                        }, "sub-menu-".concat(index, "-").concat(url));
                    })
                })
            ]
        })
    });
};
HeaderSub.defaultProps = defaultProps;
HeaderSub.propTypes = propTypes;

;// CONCATENATED MODULE: ./src/view/HeaderSub/index.js

/* harmony default export */ var view_HeaderSub = (HeaderSub);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [9774,2888,179], function() { return __webpack_exec__(71652); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);